import useAsyncData from "../../../../hooks/use-async-data";
import mileageService from "../../mileage.service";
import MileageSettingsDetails from "./mileage-settings-details";
import MileageSettingsDetailsParams from "./mileage-settings-details-params";

const useMileageSettingsDetails = () => {
  const { isLoading, setIsLoading, isError, setIsError, data, setData } =
    useAsyncData<MileageSettingsDetails | null>(null);

  const load = async (
    params: MileageSettingsDetailsParams,
    abortSignal: AbortSignal,
  ) => {
    setIsLoading(true);
    setIsError(false);

    try {
      const details = await mileageService.getSettingsDetails(
        params,
        abortSignal,
      );
      setData(details);
    } catch (error) {
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    isLoading,
    isError,
    data,
    load,
  };
};

export default useMileageSettingsDetails;
